
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e/[event]",
      function () {
        return require("private-next-pages/e/[event].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e/[event]"])
      });
    }
  